<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar style="color: white" color="secondary">
        <h3>{{message}}</h3>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div class="columns" id="columns">
      <v-card class="column is-one-quarter">
        <v-subheader v-if="rightPanelHeading != null">{{rightPanelHeading}}</v-subheader>
        <v-list>
        <template v-for="(item, index) in items">

        <v-list-item
          @click="itemSelected(item)"
          :key="index"
        >
          <v-list-item-content class="list-item">
            <v-list-item-title class="text-wrap">
              {{
              item.committer
              }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              {{item.timestamp | moment("DD.MM.YYYY HH:mm")}}
            </v-list-item-subtitle>
          </v-list-item-content>

        </v-list-item>
        <v-divider :key="item.commitHash" class="ma-0 pa-0" />
        </template>
        </v-list>
      </v-card>
    <div class="column">
      <div id="viewerFrame" v-if="selectedItem != null">
        <BpmnViewer v-if="dialog" ref="bpmnViewer" :diagramXML="selectedItem.processXML"/>  
      </div>
      <div v-else>
        <p v-if="items.length == 0" style="text-align-last: center; margin: 10px; font-size:1.25rem;">Es sind leider keine Prozesse zum verknüpfen vorhanden. Fügen Sie neue Prozesse zur Plattform hinzu um diese verknüpfen zu können.</p>
        <p v-else style="text-align-last: center; margin: 10px; font-size:1.25rem;">Prozess auswählen um Vorschau anzuzeigen</p>    
      </div>
    </div>
  </div>
      <!-- <div v-if="loaded">
        <BpmnViewer v-if="dialog" ref="bpmnViewer" :diagramXML="selectedProcessXml" style="margin-top: 64px" />  
      </div>
      <div v-else>
        <p v-if="availableProcesses.length == 0" style="text-align-last: center; margin: 10px; font-size:1.25rem;">Es sind leider keine Prozesse zum verknüpfen vorhanden. Fügen Sie neue Prozesse zur Plattform hinzu um diese verknüpfen zu können.</p>
        <p v-else style="text-align-last: center; margin: 10px; font-size:1.25rem;">Prozess auswählen um Vorschau anzuzeigen</p>    
      </div> -->
      <div id="footer">
          <v-btn style="float:right;" color="primary" @click="chooseItem">
            {{btnText}}
          </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
export default {
  name: "PreviewProcessModelDialog",
  components:{
    BpmnViewer
  },
  props:{
    
  },
  data() {
    return {
      dialog: true,
      resolve: null,
      reject: null,
      selectedItem: null,
      items: [],
      rightPanelHeading: "",
      message: "",
      btnText: ""
    }
  },
  methods: {
    itemSelected(item){
      this.selectedItem = item;
    },
    open(items, message, btnText,  rightPanelHeading) {
      this.selectedProcess = null;
      this.items = items;
      this.message = message;
      this.btnText = btnText;
      this.rightPanelHeading = rightPanelHeading;
      this.selectedProcess = items[0];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    closeDialog(){
      this.reject();
      this.$emit('close');
      this.dialog = false;
    },
    chooseItem(item){
      this.resolve(this.selectedItem);
      this.dialog = false;
    }
  }
};
</script>

<style>
#viewerFrame{
  position: absolute;
  right: 0;
  left: 25%;
  bottom: 0;
  top:0;

}
#columns{
  margin:0;
  position:absolute;
  height: calc(100% - (2*64px));
  width:100%;
}
.dialog {
  flex-grow: 0;
  padding: 20px;
  background-color: #fff;
}
.description{
  display:inline-block;
  width: calc(60% - 5px);
  height: 400px;
  margin: 15px 5px 0 0;
}
.modelList{
  display:inline-block;
  width: calc(40% - 15px);
  height: 400px;
  margin: 5px 0 0 15px;
  border-left: 2px solid var(--v-primary-base);
}
.elementDivider{

  margin: 1px;
  border: 0.5px solid var(--v-primary-base);
}
#footer{
  position: absolute;
  width:100%;
  bottom: 0;
  background-color: var(--v-secondary-base);
  padding:10px;
  height:64px;
}

</style>